// extracted by mini-css-extract-plugin
export var button = "styles-module--button--08a53";
export var product = "styles-module--product--92279";
export var productSkeleton = "styles-module--product-skeleton--d0745";
export var selectedProducts__container = "styles-module--selected-products__container--c93d6";